import React from 'react';
import './order-details.scss';
import { TagChip } from '../../components';
import { Tag } from '@zonofi/zono-money-store';

const TAGS_SHOW_COUNT = 3;

interface OrderInfoCardProps {
  icon: string;
  title: string;
  value: string | Tag[];
}

export const OrderInfoCard: React.FC<OrderInfoCardProps> = ({
  icon,
  title,
  value,
}) => {
  const isTagsSection = title === 'Tags';
  const tags = Array.isArray(value) ? value : [];
  const extraTagsCount = tags.length - TAGS_SHOW_COUNT;

  return (
    <div className="order-info-row">
      <img src={icon} />
      <span className="order-info-row-label font-medium">{`${title}:`}</span>

      {isTagsSection && tags.length > 0 ? (
        <div className="order-tags-container">
          {tags.slice(0, TAGS_SHOW_COUNT).map((tag) => (
            <TagChip key={tag.id} tagName={tag.name} />
          ))}
          {extraTagsCount > 0 && <TagChip tagName={`+${extraTagsCount}`} />}
        </div>
      ) : (
        typeof value === 'string' && (
          <span className="order-info-row-value font-medium">{value}</span>
        )
      )}
    </div>
  );
};
